import { AnimatePresence, motion } from "framer-motion";
import { useTabletOrMobile } from "../../../hooks/responsive";
import UserProfile from "../../UserProfile";
import { createPortal } from "react-dom";
import { BackButton } from "../../../pages/account/kit";

export default function UserProfileBottomSheet({ showUserProfile, setShowUserProfile, userId }) {
  const isMobile = useTabletOrMobile();

  return createPortal(
    <AnimatePresence>
      {isMobile && showUserProfile && (
        <motion.div
          key="profile-sheet"
          className="tw-fixed tw-inset-0 tw-z-[100000]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {/* Semi-transparent backdrop (visual only) */}
          <div className="tw-absolute tw-inset-0 tw-bg-[rgba(0,22,36,0.45)]" />

          {/* Panel — comes after backdrop in DOM so it's always on top */}
          <motion.div
            className="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-overflow-hidden tw-bg-white"
            initial={{ x: "100%" }}
            animate={{
              x: 0,
              transition: { type: "spring", damping: 25, stiffness: 300 },
            }}
            exit={{
              x: "100%",
              transition: { type: "spring", damping: 30, stiffness: 300 },
            }}
          >
            {/* Header — the account pages' bar (pages/account/kit.js) */}
            <div className="club-admin tw-flex tw-h-14 tw-flex-shrink-0 tw-items-center tw-border-b tw-border-[var(--hairline)] tw-px-4">
              <BackButton onClick={() => setShowUserProfile(false)} />
            </div>

            {/* Scrollable content */}
            <div className="tw-flex-1 tw-overflow-y-auto">
              <UserProfile passing_user_id={userId} hideFixedActionButton />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
}
